module.exports = __webpack_public_path__ + "img/bg.d01deeb5.svg";